import ApplicationController from './application_controller';

/**
 * Spam protection controller
 *
 * Sets a JS-computed challenge token on page load to prove the form
 * was loaded in a real browser with JavaScript enabled.
 *
 * Usage:
 * <form data-controller="spam-protection"
 *       data-spam-protection-loaded-at-value="<timestamp>"
 *       data-spam-protection-secret-value="<secret>">
 *   <input type="hidden" name="form_loaded_at" data-spam-protection-target="loadedAt">
 *   <input type="hidden" name="js_token" data-spam-protection-target="token">
 * </form>
 */
export default class extends ApplicationController {
  static targets = ['loadedAt', 'token'];
  static values = {
    loadedAt: String,
    secret: String,
  };

  connect() {
    this.setToken();
  }

  async setToken() {
    const loadedAt = this.loadedAtValue;
    const secret = this.secretValue;

    if (this.hasLoadedAtTarget) {
      this.loadedAtTarget.value = loadedAt;
    }

    if (this.hasTokenTarget && loadedAt && secret) {
      const payload = `${loadedAt}:${secret}`;
      const hash = await this.sha256(payload);
      this.tokenTarget.value = hash.substring(0, 32);
    }
  }

  async sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  }
}
